import dayjs from "dayjs";

export const getNotificationRelativeTime = (dateTime) => {
  const now = dayjs();
  const date = dayjs(dateTime);

  const diffMinutes = now.diff(date, "minute");
  const diffHours = now.diff(date, "hour");

  if (diffMinutes < 1) {
    return "Just now";
  }

  if (diffMinutes < 60) {
    return `${diffMinutes} min ago`;
  }

  if (diffHours < 24) {
    return `${diffHours} ${diffHours === 1 ? "hour" : "hours"} ago`;
  }

  return date.format("DD MMM YYYY, hh:mm A");
};
